import React from 'react';
import { TtsProvider } from '@/api-gen/api.schemas';
import googleLogo from '/icons/google.png?url';
import microsoftLogo from '/icons/microsoft.png?url';
import elevenlabsLogo from '/icons/elevenlabs.svg?url';
import skllsLogo from '/icons/logo-minimal.svg?url';

interface TtsProviderLogoProps {
  provider: TtsProvider;
  size?: 'small' | 'medium';
  style?: React.CSSProperties;
}

export const TtsProviderLogo: React.FC<TtsProviderLogoProps> = ({ 
  provider, 
  size = 'small',
  style = {} 
}) => {
  const getTtsProviderLogo = (ttsProvider: TtsProvider): string => {
    switch (ttsProvider) {
      case TtsProvider.Google:
        return googleLogo;
      case TtsProvider.Microsoft:
        return microsoftLogo;
      case TtsProvider.ElevenLabs:
        return elevenlabsLogo;
      case TtsProvider.InHouse:
        return skllsLogo;
      default:
        return skllsLogo;
    }
  };

  const logoSrc = getTtsProviderLogo(provider);
  
  const baseStyle = {
    height: size === 'small' ? '1.2rem' : '1.5rem',
    width: size === 'small' ? '1.2rem' : '1.5rem',
    objectFit: 'contain' as const,
    verticalAlign: 'middle',
    ...style
  };

  return (
    <img 
      src={logoSrc} 
      alt={`${provider} logo`} 
      style={baseStyle}
    />
  );
};
